import { render, staticRenderFns } from "./NroViajeBiomasaClienteEspecie.vue?vue&type=template&id=d4219d74&scoped=true&"
import script from "./NroViajeBiomasaClienteEspecie.vue?vue&type=script&lang=js&"
export * from "./NroViajeBiomasaClienteEspecie.vue?vue&type=script&lang=js&"
import style0 from "./NroViajeBiomasaClienteEspecie.vue?vue&type=style&index=0&id=d4219d74&scoped=true&lang=css&"
import style1 from "./NroViajeBiomasaClienteEspecie.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d4219d74",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VCol,VRow,VSelect,VSimpleTable})
